<template>
  <div class='iccube'>
    <div v-if="errorMessage" class="alert">
      {{ errorMessage }}
    </div>
    <div v-if="loading" class="loading">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div id="is3-dashboard"></div>
  </div>
</template>

<script>
import { DashboardsLoaderDivContext } from '@ic3/reporting-api-embedded'
import { mapGetters } from 'vuex'
import Api from '@/api'
import { getAuthHeader } from '@/utils/axios.instances'

export default {
  name: 'iccube',
  data () {
    return {
      ic3reporting: null,
      lastCustomHeadersRequest: null,
      errorMessage: '',
      reportPath: '',
      loading: true
    }
  },
  computed: {
    ...mapGetters(['scantrustAuthToken'])
  },
  watch: {
    scantrustAuthToken (newToken, oldToken) {
      if (!newToken || newToken === oldToken || this.ic3reporting == null) {
        return
      }

      this.sendTokenToIccubeFrame(this.lastCustomHeadersRequest || { ic3callerType: 'div' })
    }
  },
  created () {
    console.log('query', this.$route.query)
    this.reportPath = this.$route.query.report
    console.log('report name', this.reportPath)
  },
  mounted () {
    this.initEventHandler()
    this.initIccube()

    console.log('parent', window.parent)
  },
  methods: {
    openDashboard (path) {
      if (this.ic3reporting != null) {
        this.ic3reporting.openReport({
          path: path,
          onDefinition: (report) => {
            console.log('[ic3-demo] open-report:' + report.getPath() + ' - onDefinition', report)
            this.loading = false
          },
          onError: (error) => {
            console.log('[ic3-demo] open-report: ' + path + ' - onError', error)
            this.errorMessage = error
            this.loading = false
            return true
          }
        })
      }
    },
    initIccube () {
      console.log('init iccube')
      this.loading = true

      // div connect
      const urlHome = Api.iccube_url
      const context = new DashboardsLoaderDivContext({ customHeaders: 'dashboards', urlHome: urlHome })
      const container = document.getElementById('is3-dashboard')

      if (container == null) {
        this.errorMessage = 'container not found'
        return
      }
      // load dashboard
      const options = {
        uid: 'container1',
        container: container
      }
      context.loadLibsAndInitialize(options).then((reporting) => {
        console.log('ic3ready : ', reporting)
        this.ic3reporting = reporting

        this.openDashboard(this.reportPath)
      }).catch((error) => {
        this.loading = false
        this.errorMessage = error
        console.error(error)
      })
    },

    // requestToken () {
    //   parent.postMessage({ type: 'jwt-request' }, '*')
    // },

    sendTokenToIccubeFrame (data) {
      const embeddedDiv = (data.ic3callerType === 'div')
      const target = !embeddedDiv ? document.getElementById('ic3-iframe') && document.getElementById('ic3-iframe')?.contentWindow : window

      if (target == null) {
        return
      }

      const authHeader = getAuthHeader(this.scantrustAuthToken)
      console.log('token sent to iccube:', authHeader)
      target.postMessage({
        type: 'ic3-custom-headers-reply',
        data: {
          headers: {
            Authorization: authHeader
          }
        }
      }, '*')
    },

    initEventHandler () {
      const eventMethod = window.addEventListener
        ? 'addEventListener'
        : 'attachEvent'
      const eventer = window[eventMethod]
      const messageEvent = eventMethod === 'attachEvent'
        ? 'onmessage'
        : 'message'

      eventer(messageEvent, (e) => {
        const data = e.data
        if (data.type === 'ic3-custom-headers-request') {
          this.lastCustomHeadersRequest = data
          this.sendTokenToIccubeFrame(data)
        }
      })
    }
  }
}

</script>

<style lang='sass' scoped>

#is3-dashboard
  height: 100vh
  width: 100%

.alert
  padding: 1rem 0 1rem 1.5rem

.loading
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    margin: auto
    z-index: 9999
    background: rgba(white, 0.8)
    display: flex
    align-content: center
    justify-content: center
    align-items: center

.lds-ring
  display: inline-block
  position: relative
  width: 80px
  height: 80px
  div
    box-sizing: border-box
    display: block
    position: absolute
    width: 64px
    height: 64px
    margin: 8px
    border: 8px solid #15bbf0
    border-radius: 50%
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite
    border-color: #15bbf0 transparent transparent transparent
    &:nth-child(1)
      animation-delay: -0.45s
    &:nth-child(2)
      animation-delay: -0.3s
    &:nth-child(3)
      animation-delay: -0.15s

@keyframes lds-ring
  0%
    transform: rotate(0deg)
  100%
    transform: rotate(360deg)
</style>
